'use strict';
var uniqueRandom = require('unique-random');

module.exports = function (arr) {
	var rand = uniqueRandom(0, arr.length - 1);

	return function () {
		return arr[rand()];
	};
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/unique-random-array/index.js
// module id = 1572
// module chunks = 0 1 2